export enum TeamStatus {
    ACTIVE = "active",
    STOPPED = "stopped",
    PAUSED = "paused"
}